/**
 * Impact area-metrics lookup — strictly the live CDN dataset, no bundled or
 * generated fallback. Returns `undefined` when the live dataset hasn't
 * loaded yet or doesn't cover a given FIPS; callers must render an explicit
 * "not available" state rather than invent a number.
 */
import type { AreaMetrics } from '../data/impactTypes';
import { getLiveAreaRecord } from './locationMetricsService';
import type { GeoLevel } from '../types';

/** Metrics for a single area by FIPS — `undefined` if not (yet) live. */
export function getAreaMetrics(level: GeoLevel, fips: string): AreaMetrics | undefined {
  const record = getLiveAreaRecord(level, fips);
  return record ? { code: fips, ...record } : undefined;
}

/** Display name for a FIPS — `undefined` if not (yet) live. */
export function getAreaName(level: GeoLevel, fips: string): string | undefined {
  return getLiveAreaRecord(level, fips)?.name;
}

export { loadLocationMetrics } from './locationMetricsService';
